<div class="container">

    <div class="row">
        <div class="col-md-12 text-center pad-top-80">
            <h1 class="color-orange border-new-line">International Shipping Destinations with Shippn</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 pad-top-80 pad-bottom-80">
            <div class="bfm-countries-wrapper">
                <div class="bfm-country" *ngFor="let country of hostCountries | slice:0:5" [routerLink]="['/', lang,'shop-from', country?.code]" [queryParams]="loggedUser?.has_orders === false ? { user: 'new' } : null">
                    <div class="bfm-country-flag" >
                        <img async src="https://www.shippn.com/assets/img/flags/{{country.country_flag}}"
                            alt="BFM Country Flag">
                    </div>
                    <div class="bfm-country-name">
                        <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                      <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
                    </div>
                </div>
                <div class="bfm-country" *ngFor="let country of hostCountries | slice:5:10" [routerLink]="['/', lang,'shop-from', country?.code]" [queryParams]="loggedUser?.has_orders === false ? { user: 'new' } : null">
                    <div class="bfm-country-flag">
                        <img async src="https://www.shippn.com/assets/img/flags/{{country.country_flag}}"
                            alt="BFM Country Flag">
                    </div>
                    <div class="bfm-country-name">
                        <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                      <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
                    </div>
                </div>
                <div class="bfm-country" *ngFor="let country of hostCountries | slice:10:15" [routerLink]="['/', lang,'shop-from', country?.code]" [queryParams]="loggedUser?.has_orders === false ? { user: 'new' } : null">
                    <div class="bfm-country-flag">
                        <img async src="https://www.shippn.com/assets/img/flags/{{country.country_flag}}"
                            alt="BFM Country Flag" *ngIf="country.code != 'TP'">
                    </div>
                    <div class="bfm-country-name">
                        <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                      <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
                    </div>
                </div>
                <div class="bfm-country" *ngFor="let country of hostCountries | slice:15:20" [routerLink]="['/', lang,'shop-from', country?.code]" [queryParams]="loggedUser?.has_orders === false ? { user: 'new' } : null">
                    <div class="bfm-country-flag">
                        <img async src="https://www.shippn.com/assets/img/flags/{{country.country_flag}}"
                            alt="BFM Country Flag" *ngIf="country.code != 'TP'">
                    </div>
                    <div class="bfm-country-name">
                        <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                      <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
                    </div>
                </div>
                <div class="bfm-country" *ngFor="let country of hostCountries | slice:20:25" [routerLink]="['/', lang,'shop-from', country?.code]" [queryParams]="loggedUser?.has_orders === false ? { user: 'new' } : null">
                    <div class="bfm-country-flag">
                        <img async src="https://www.shippn.com/assets/img/flags/{{country.country_flag}}"
                            alt="BFM Country Flag" *ngIf="country.code != 'TP'">
                    </div>
                    <div class="bfm-country-name">
                        <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                      <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
                    </div>
                </div>
                <div class="bfm-country" *ngFor="let country of hostCountries | slice:25:30" [routerLink]="['/', lang,'shop-from', country?.code]" [queryParams]="loggedUser?.has_orders === false ? { user: 'new' } : null">
                    <div class="bfm-country-flag">
                        <img async src="https://www.shippn.com/assets/img/flags/{{country.country_flag}}"
                            alt="BFM Country Flag" *ngIf="country.code != 'TP'">
                    </div>
                    <div class="bfm-country-name">
                        <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                      <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
                    </div>
                </div>
                <div class="bfm-country" *ngFor="let country of hostCountries | slice:30:35" [routerLink]="['/', lang,'shop-from', country?.code]" [queryParams]="loggedUser?.has_orders === false ? { user: 'new' } : null">
                    <div class="bfm-country-flag">
                        <img async src="https://www.shippn.com/assets/img/flags/{{country.country_flag}}"
                            alt="BFM Country Flag" *ngIf="country.code != 'TP'">
                    </div>
                    <div class="bfm-country-name">
                        <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                      <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
                    </div>
                </div>
                <div class="bfm-country" *ngFor="let country of hostCountries | slice:35:40" [routerLink]="['/', lang,'shop-from', country?.code]" [queryParams]="loggedUser?.has_orders === false ? { user: 'new' } : null">
                    <div class="bfm-country-flag">
                        <img async src="https://www.shippn.com/assets/img/flags/{{country.country_flag}}"
                            alt="BFM Country Flag" *ngIf="country.code != 'TP'">
                    </div>
                    <div class="bfm-country-name">
                        <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                      <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>